import { DefaultButton, PrimaryButton } from "@fluentui/react";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "../Hospital/hospital.module.css";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import { DeleteIcon } from "@fluentui/react-icons-mdl2";
const HPColumns = (changeActiveStatus, handleRemoveHP, userRole) => {
  const [t, i18n] = useTranslation();

  const childTrPadding =
    process.env.REACT_APP_HYBRID_MODE == "false"
      ? "15px 0px 15px 10px"
      : "15px 10px";
  const rowTrPadding = "0px 10px";

  return [
    {
      id: "name",
      style: { width: "15vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: "15px 0px 15px 10px",
        textAlign: "left",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-user-details-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Details</span>,
      accessor: "hpLists",
      accessorKey: "hpLists",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.name}</div>
          </div>

          <div>
            <div className="user-heading">Description</div>
            <div className="user-sub-heading">{cell.row.original.description ? cell.row.original.description : "-"}</div>
          </div>
        </>
      ),
    },
    {
      id: "hpLayout",
      style: { width: "15vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: "15px 0px 15px 10px",
        textAlign: "left",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-user-details-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Layout</span>,
      accessor: "hpLists",
      accessorKey: "hpLists",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.layout.name}</div>
          </div>

          <div>
            <div className="user-heading">Rows x Columns</div>
            <div className="user-sub-heading">{cell.row.original.layout.rows +" x "+cell.row.original.layout.columns}</div>
          </div>
        </>
      ),
    },
    {
      id: "Type",
      style: { width: "15vw", boxSizing: "border-box", padding: rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "15vw !important",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-firm-type-header",
      classChildName: "break-word cursor-pointer column-firm-type-header",
      header: () => <span>Status</span>,
      accessor: "type",
      accessorKey: "type",
      show: true,
      cell: (cell) => (
        <>
          <div className="user-mt-10">
            <div className="user-heading">Status</div>
            <div className="user-sub-heading">
              {!cell.row.original.active ? (
                <>
                  <span className="inactive-red-dot"></span>
                  {t("hospital.inactive")}
                </>
              ) : (
                <>
                  <span className="active-green-dot"></span>
                  {t("hospital.active")}
                </>
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "action",
      style: {
        width: "15vw",
        display: "flex",
        height: "80px",
        alignItems: "center",
        boxSizing: "border-box",
      },
      headerClass: "break-word column-user-contact-header",
      classChildName: "break-word cursor-pointer column-user-contact-header",
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "20vw !important",
      },
      header: () => <span>{t("supervisor.action")}</span>,
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => (
        <>
          {!cell.row.original.active ? (
            <PrimaryButton
              text={t("hospital.activate")}
              onClick={(event) =>
                changeActiveStatus(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          ) : (
            <DefaultButton
              text={t("hospital.deactivate")}
              onClick={(event) =>
                changeActiveStatus(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          )}


          <PrimaryButton
              text={t("hanging-protocol.delete")}
              onClick={(event) =>
                handleRemoveHP(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
                marginLeft:"40px",
              }}
            />
          {/* <div
            onClick={(event) =>
              handleRemoveHP(event, cell.row.original.id, cell)
            }
            style={{
              padding: "0",
              marginLeft:"40px",
            }}
          >
            <DeleteIcon/>
          </div> */}
        </>
      ),
    },
  ];
};
export default HPColumns;
